




















import { Vue, Component, Prop } from 'vue-property-decorator'
import LinhaDeCategoriaDoMix from './LinhaDeCategoriaDoMix.vue'
import type { CategoriaDoMixDoCliente } from '@/models'
import { TEXTO_SEM_DADOS } from '@/shareds/painel-do-cliente-shareds'
import { ordenarMixDeCategorias, resumirMix } from '@/shareds/painel-do-cliente-mix-shareds'

@Component({
	components: {
		LinhaDeCategoriaDoMix,
	},
})
export default class MixDeCategorias extends Vue {
	@Prop({ type: Array, default: () => [] }) categorias!: CategoriaDoMixDoCliente[]
	@Prop({ type: Boolean, default: true }) resumido!: boolean

	textoSemDados = TEXTO_SEM_DADOS

	get exibidas() {
		return this.resumido ? resumirMix(this.categorias).principais : ordenarMixDeCategorias(this.categorias)
	}

	get rodape() {
		return this.resumido ? resumirMix(this.categorias).rodape : null
	}
}
